import { useEffect, useState } from "react";
import axios from "axios";

const API =
  process.env.REACT_APP_API_URL ||
  "https://homefoods-backend-production.up.railway.app/api";

export default function useFoods() {
  const [foods, setFoods] = useState([]);

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  const token = localStorage.getItem("token");

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // ==========================
  // Fetch Foods
  // ==========================

  const fetchFoods = async () => {
    try {
      setLoading(true);
      console.log("API Base:", API);
console.log("Request URL:", `${API}/food/my-foods`);

      const res = await axios.get(
        `${API}/food/my-foods`,
        config
      );
      console.log("Foods Response:", res.data);

      setFoods(res.data.foods || []);

      setError("");
    } catch (err) {
      console.error(err);

      setError(
        err.response?.data?.message ||
          "Unable to load foods."
      );
    } finally {
      setLoading(false);
    }
  };

  // ==========================
  // Add Food
  // ==========================

  const addFood = async (foodData) => {
    try {
      setLoading(true);

      const formData = new FormData();

      Object.keys(foodData).forEach((key) => {
        if (key === "tags") {
          formData.append(
            "tags",
            JSON.stringify(foodData.tags)
          );
        } else {
          formData.append(key, foodData[key]);
        }
      });

      const res = await axios.post(
  `${API}/food/add`,
  formData,
  {
    headers: {
      ...config.headers,
      "Content-Type": "multipart/form-data",
    },
  }
);

     setFoods((prev) => [res.data.food, ...prev]);

      return true;
    } catch (err) {
      console.error(err);

      setError(
        err.response?.data?.message ||
          "Unable to add food."
      );

      return false;
    } finally {
      setLoading(false);
    }
  };

  // ==========================
  // Update Food
  // ==========================

  const updateFood = async (
    id,
    foodData
  ) => {
    try {
      setLoading(true);

      const formData = new FormData();

      Object.keys(foodData).forEach((key) => {
        if (key === "tags") {
          formData.append(
            "tags",
            JSON.stringify(foodData.tags)
          );
        } else {
          formData.append(key, foodData[key]);
        }
      });

      const res = await axios.put(
        `${API}/food/${id}`,
        formData,
        {
          headers: {
            ...config.headers,
            "Content-Type":
              "multipart/form-data",
          },
        }
      );

      setFoods((prev) =>
        prev.map((food) =>
          food._id === id ? res.data.food : food
        )
      );

      return true;
    } catch (err) {
      console.error(err);

      setError(
        err.response?.data?.message ||
          "Unable to update food."
      );

      return false;
    } finally {
      setLoading(false);
    }
  };

  // ==========================
  // Delete Food
  // ==========================

  const deleteFood = async (id) => {
    try {
      setLoading(true);

      await axios.delete(
        `${API}/food/${id}`,
        config
      );

      setFoods((prev) =>
        prev.filter(
          (food) => food._id !== id
        )
      );

      return true;
    } catch (err) {
      console.error(err);

      setError(
        err.response?.data?.message ||
          "Unable to delete food."
      );

      return false;
    } finally {
      setLoading(false);
    }
  };

  // ==========================
// Toggle Availability
// ==========================

const toggleAvailability = async (id) => {
  try {
    const res = await axios.patch(
      `${API}/food/${id}/toggle`,
      {},
      config
    );

    setFoods((prev) =>
      prev.map((food) =>
        food._id === id ? res.data.food : food
      )
    );

    return true;
  } catch (err) {
    console.error(err);

    setError(
      err.response?.data?.message ||
        "Unable to update availability."
    );

    return false;
  }
};

  useEffect(() => {
    fetchFoods();
  }, []);

  return {
    foods,

    loading,

    error,

    fetchFoods,

    addFood,

    updateFood,

    deleteFood,

     toggleAvailability,
  };
}

    